module.exports = __webpack_public_path__ + "img/shrines-1-60.19785daf.jpg";